jQuery(document).ready(function($) {
    'use strict';

    // Hero Swiper
    var hero_swiper = new Swiper('.hero .swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
    });

    // Image Swiper
    $('.image-slider').each(function() {
        var $slider = $(this);

        new Swiper($slider.get(0), {
            slidesPerView: 1,
            grabCursor: true,
            speed: 700,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: $slider.find('.swiper-button-next').get(0),
                prevEl: $slider.find('.swiper-button-prev').get(0),
            },
        });
    });

    // Services Swiper
    $('.services-swiper-slider').each(function() {
        var $slider = $(this);
        var $block = $slider.closest('.services-swiper');

        new Swiper($slider.get(0), {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            speed: 500,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            scrollbar: {
                el: $slider.find('.services-swiper-scrollbar').get(0),
                draggable: true,
            },
            navigation: {
                nextEl: $block.find('.services-swiper-next').get(0),
                prevEl: $block.find('.services-swiper-prev').get(0),
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                },
            },
        });
    });

    // Blog Swiper
    $('.blog-swiper-slider').each(function() {
        var $slider = $(this);
        var $block = $slider.closest('.blog-swiper');

        new Swiper($slider.get(0), {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            speed: 500,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            scrollbar: {
                el: $slider.find('.blog-swiper-scrollbar').get(0),
                draggable: true,
            },
            navigation: {
                nextEl: $block.find('.blog-swiper-next').get(0),
                prevEl: $block.find('.blog-swiper-prev').get(0),
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                },
            },
        });
    });

    // Imprint Swiper
    $('.imprint-swiper-slider').each(function() {
        var $slider = $(this);
        var $block = $slider.closest('.imprint-swiper');

        new Swiper($slider.get(0), {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            speed: 500,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            scrollbar: {
                el: $slider.find('.imprint-swiper-scrollbar').get(0),
                draggable: true,
            },
            navigation: {
                nextEl: $block.find('.imprint-swiper-next').get(0),
                prevEl: $block.find('.imprint-swiper-prev').get(0),
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                },
            },
        });
    });

    // Gallery
    $('.gallery-slider').each(function() {
        var $slider = $(this);

        // The right-edge fade only makes sense while there's more to
        // scroll to — drop it once the last image is fully in view so it
        // reads clearly instead of staying permanently dimmed.
        function updateEndFade(swiper) {
            $slider.toggleClass('is-end', swiper.isEnd);
        }

        new Swiper($slider.get(0), {
            slidesPerView: 'auto',
            // Spacing is set in CSS (.gallery-slider .swiper-wrapper { gap })
            // instead of here, so it's already correct before this script
            // and Swiper have loaded, not just once Swiper applies it.
            spaceBetween: 0,
            grabCursor: true,
            speed: 500,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            on: {
                init: updateEndFade,
                progress: updateEndFade,
                resize: updateEndFade,
            },
        });
    });

    // Sagt om oss (Case Quote Swiper)
    $('.case-quote-swiper-slider').each(function() {
        var $slider = $(this);
        var $block = $slider.closest('.case-quote-swiper');

        new Swiper($slider.get(0), {
            slidesPerView: 1,
            speed: 500,
            grabCursor: true,
            loop: true,
            navigation: {
                nextEl: $block.find('.case-quote-swiper-next').get(0),
                prevEl: $block.find('.case-quote-swiper-prev').get(0),
            },
        });
    });

    // Process Steps
    // Unlike the other swipers, the "active" card here is whichever one sits
    // closest to an "active zone" — not the true geometric center of the
    // (full-bleed, viewport-wide) slider, which sits far to the right of
    // where the first card actually rests under the heading and made early
    // cards feel almost impossible to land on. The active zone is instead
    // anchored to that first card's resting position, and stays there as
    // you scroll. The first card counts as active at rest, then real
    // zone-tracking takes over as soon as the user starts scrolling; a
    // trailing offset lets the last card still be scrolled into the zone.
    $('.process-steps-slider').each(function() {
        var $slider = $(this);
        var $block = $slider.closest('.process-steps');
        var $slides = $slider.find('.process-steps-slide');

        function getActiveZoneX() {
            var containerRect = $slider.get(0).getBoundingClientRect();
            var paddingLeft = parseFloat(getComputedStyle($slider.get(0)).paddingLeft) || 0;
            var firstSlideWidth = $slides.first().outerWidth();
            return containerRect.left + paddingLeft + firstSlideWidth / 2;
        }

        function getOffsetAfter() {
            var containerRect = $slider.get(0).getBoundingClientRect();
            var lastSlideWidth = $slides.last().outerWidth(true);
            var naturalMaxCenter = containerRect.right - lastSlideWidth / 2;
            return Math.max(0, naturalMaxCenter - getActiveZoneX());
        }

        function updateCenterActive(swiper) {
            var closestSlide = $slides.get(0);

            if (swiper.progress > 0) {
                var activeZoneX = getActiveZoneX();
                var closestDistance = Infinity;

                // Where each slide will sit once the current slide
                // transition settles. swiper.translate is already the
                // destination while a CSS transition is running, whereas
                // getBoundingClientRect() still reports the slide's current
                // mid-animation position — using that made the selection
                // lag behind and only switch at transitionEnd (slide, then
                // select instead of slide + select).
                var wrapperLeft = $slider.get(0).getBoundingClientRect().left
                    + (parseFloat(getComputedStyle($slider.get(0)).paddingLeft) || 0)
                    + swiper.translate;

                $slides.each(function() {
                    var slideCenter = wrapperLeft + this.offsetLeft + this.offsetWidth / 2;
                    var distance = Math.abs(slideCenter - activeZoneX);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestSlide = this;
                    }
                });
            }

            // Skip the class swap entirely when nothing changed, so a
            // setTranslate flood (every pointer-move while dragging) doesn't
            // keep restarting the color transition and causing jitter.
            if ($(closestSlide).hasClass('is-center-active')) {
                return;
            }

            $slides.removeClass('is-center-active');
            $(closestSlide).addClass('is-center-active');
        }

        var process_steps_swiper = new Swiper($slider.get(0), {
            slidesPerView: 'auto',
            spaceBetween: 24,
            grabCursor: true,
            speed: 500,
            slidesOffsetAfter: getOffsetAfter(),
            // The active card's description reveal changes this slide's
            // (and so the whole row's) rendered height. With Swiper's default
            // resizeObserver watching the container, that alone was enough to
            // re-trigger its own resize handling mid-drag and fight with our
            // center detection — causing the highlight to jitter/oscillate
            // between two cards. Window resizes are still handled via the
            // regular resize listener below.
            resizeObserver: false,
            scrollbar: {
                el: $block.find('.process-steps-scrollbar').get(0),
                draggable: true,
            },
            navigation: {
                nextEl: $block.find('.process-steps-next').get(0),
                prevEl: $block.find('.process-steps-prev').get(0),
            },
            on: {
                init: updateCenterActive,
                setTranslate: updateCenterActive,
                transitionEnd: updateCenterActive,
                resize: function(swiper) {
                    swiper.params.slidesOffsetAfter = getOffsetAfter();
                    swiper.updateSlides();
                    updateCenterActive(swiper);
                },
            },
        });

        // Clicking a card moves it into the active zone (and, once settled,
        // marks it active via the transitionEnd handler above).
        $slides.on('click', function() {
            var clickedRect = this.getBoundingClientRect();
            var clickedCenter = clickedRect.left + clickedRect.width / 2;
            var delta = clickedCenter - getActiveZoneX();

            process_steps_swiper.translateTo(
                process_steps_swiper.translate - delta,
                process_steps_swiper.params.speed
            );

            // translateTo() moves the slider but doesn't update Swiper's own
            // activeIndex, which is what the prev/next nav buttons step
            // from — without this, the arrows keep navigating relative to
            // whatever slide was active before the click instead of the
            // one the user just landed on.
            process_steps_swiper.updateActiveIndex();
            process_steps_swiper.updateSlidesClasses();
        });
    });

});

window.addEventListener('load', function() {

    // Hitta alla triggers på sidan
    const triggers = document.querySelectorAll('.gallery-trigger');

    // Håll koll på aktiva instanser
    let currentSwiper = null;

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('data-target');
            const index = this.getAttribute('data-index');
            const overlay = document.getElementById(targetId);

            if (!overlay) {
                return;
            }

            openModal(overlay, index);
        });
    });

    function openModal(overlay, startIndex) {
        if (typeof Swiper === 'undefined') {
            console.error('Swiper JS missing');
            return;
        }

        const swiperContainer = overlay.querySelector('.swiper');
        const closeBtn = overlay.querySelector('.close-overlay');

        // Visa overlay
        overlay.classList.add('active');
        requestAnimationFrame(() => {
            overlay.classList.remove('opacity-0');
        });
        document.body.style.overflow = 'hidden';

        // Initiera Swiper om den inte redan finns för denna overlay
        // Vi kollar om elementet redan har en "swiper"-egenskap
        if (!swiperContainer.swiper) {
            currentSwiper = new Swiper(swiperContainer, {
                initialSlide: parseInt(startIndex),
                loop: false,
                speed: 400,
                spaceBetween: 20,
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                navigation: {
                    nextEl: overlay.querySelector('.swiper-button-next'),
                    prevEl: overlay.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: overlay.querySelector('.swiper-pagination'),
                    clickable: true,
                    type: 'bullets',
                },
            });
        } else {
            currentSwiper = swiperContainer.swiper;
            currentSwiper.slideTo(parseInt(startIndex), 0);
            currentSwiper.keyboard.enable();
        }

        // Setup Close Events (bara en gång per overlay)
        if (!overlay.hasAttribute('data-events-bound')) {

            // Stäng-knapp
            if (closeBtn) {
                closeBtn.addEventListener('click', () => closeModal(overlay));
            }

            // Klick utanför
            overlay.addEventListener('click', (e) => {
                if (e.target ===
                    overlay ||
                    e.target.classList.contains('swiper-slide') ||
                    e.target.classList.contains('swiper-wrapper')) {
                    closeModal(overlay);
                }
            });

            overlay.setAttribute('data-events-bound', 'true');
        }
    }

    function closeModal(overlay) {
        overlay.classList.add('opacity-0');

        setTimeout(() => {
            overlay.classList.remove('active');
            document.body.style.overflow = '';

            // Hämta swiper-instansen från DOM-elementet
            const swiperContainer = overlay.querySelector('.swiper');
            if (swiperContainer && swiperContainer.swiper) {
                swiperContainer.swiper.keyboard.disable();
            }
        }, 300);
    }

    // Global ESC lyssnare
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const activeOverlay = document.querySelector(
                '.timeline-overlay.active');
            if (activeOverlay) {
                closeModal(activeOverlay);
            }
        }
    });

});
